import { Phone, MessageCircle } from "lucide-react";
import { PHONE_TEL, WA_LINK } from "@/constants/site";

const base =
  "inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-[transform,background-color,color,border-color] duration-300 hover:-translate-y-0.5";

export const CallButton = ({ testid = "call-now-button", light = false, className = "" }) => (
  <a
    data-testid={testid}
    href={PHONE_TEL}
    className={`${base} bg-[#C85A32] text-[#FAF8F5] hover:bg-[#A8481F] ${className}`}
  >
    <Phone size={16} strokeWidth={2.2} />
    Chiama Ora
  </a>
);

export const WhatsAppButton = ({
  testid = "whatsapp-cta-button",
  light = false,
  className = "",
}) => (
  <a
    data-testid={testid}
    href={WA_LINK}
    target="_blank"
    rel="noreferrer"
    className={`${base} border ${
      light
        ? "border-[#FAF8F5]/30 text-[#FAF8F5] hover:border-[#FAF8F5] hover:bg-[#FAF8F5] hover:text-[#161514]"
        : "border-[#1A1918]/25 text-[#1A1918] hover:border-[#1A1918] hover:bg-[#1A1918] hover:text-[#FAF8F5]"
    } ${className}`}
  >
    <MessageCircle size={16} strokeWidth={2.2} />
    Scrivi su WhatsApp
  </a>
);
